import { Box, Divider, Flex } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import { UserProfile } from '../../../../../../__generated__/GQL';
import Button from '../../../../../../components/_core/Button';
import Heading from '../../../../../../components/_core/Heading';
import { formatTitle } from '../../../../../../helpers/user/formatTitle';
import { User } from '../../../../legacy/types';
import DownloadAppSection from '../DownloadAppSection';
import locales from './locales';

interface SoloKycContentProps {
  user: User;
  onViewNextSteps?: () => void;
}

const SoloKycContent = ({ onViewNextSteps, user }: SoloKycContentProps) => {
  return (
    <Flex flexDirection="column">
      <Heading fontWeight="weight-500" marginBottom="space-8" size="lg">
        {locales.heading}
      </Heading>
      <Text>{locales.summary}</Text>
      <Text marginBottom="space-32" variant="primary">
        {user.email}
      </Text>
      <Text
        fontWeight="weight-500"
        marginBottom="space-24"
        size="lg"
        variant="primary"
      >
        {locales.nextStepsHeading}
      </Text>
      <Text fontWeight="weight-500" marginBottom="space-4" variant="primary">
        {locales.formatString(
          locales.nextStepsSubject,
          formatTitle(user as UserProfile),
        )}
      </Text>
      <Text>{locales.nextStepsDescription}</Text>
      {onViewNextSteps ? (
        <Box marginTop="space-16">
          <Button onClick={onViewNextSteps} variant="inline-secondary">
            {locales.viewNextSteps}
          </Button>
        </Box>
      ) : null}
      <Divider marginY="space-24" />
      <DownloadAppSection />
    </Flex>
  );
};

export default SoloKycContent;
